export * from './components/employee/employee.component';
export * from './components/employee-detail/employee-detail.component';
export * from './employee.module';



// WEBPACK FOOTER //
// ./src/app/employee/index.ts